import script from "./BaseRibbon45Rotate.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRibbon45Rotate.vue?vue&type=script&setup=true&lang=js"

import "./BaseRibbon45Rotate.vue?vue&type=style&index=0&id=37a9eefc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37a9eefc"]])

export default __exports__